/* unplugin-vue-components disabled */import { render } from "./drawRules.vue?vue&type=template&id=482ccde1&scoped=true"
import script from "./drawRules.vue?vue&type=script&lang=js"
export * from "./drawRules.vue?vue&type=script&lang=js"

import "./drawRules.vue?vue&type=style&index=0&id=482ccde1&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482ccde1"]])

export default __exports__